var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGear = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "8 8 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15 17A2 2 0 1 1 15 12.998 2 2 0 0 1 15 17m7-1v-2l-1.732-.577a5.4 5.4 0 0 0-.427-1.034l.816-1.632-1.414-1.414-1.632.816a5.5 5.5 0 0 0-1.033-.427L16 8h-2l-.577 1.732a5.5 5.5 0 0 0-1.034.427l-1.631-.816-1.415 1.414.816 1.632a5.5 5.5 0 0 0-.427 1.034L8 14v2l1.732.578c.109.36.25.708.427 1.033l-.816 1.632 1.415 1.414 1.63-.816q.492.265 1.035.427L14 22h2l.578-1.732c.36-.108.708-.25 1.033-.427l1.632.816 1.414-1.414-.816-1.632c.177-.325.319-.672.427-1.033z"
})));
export default SvgGear;